export default {
  stores: [],
};
